// import React from "react";

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import html2canvas from "html2canvas";
import $ from "jquery";
import jsPDF from "jspdf";
import { fabric } from "fabric";
import moment from 'moment';
moment.suppressDeprecationWarnings = true;

const Download = ({ chartid, chartData, chartLables }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const container = useRef(null);

  const exportCanvasAsPNG = (event, id, fileName, fileType) => {
    $("." + id + " canvas").attr("id", id + "canvas");
    var canvasElement = document.getElementById(id + "canvas");

    canvasElement.style.background = 'white';

    var imgURL;
    var MIME_TYPE = "";
    if (fileType === "PNG") {
      MIME_TYPE = "image/png";
      imgURL = canvasElement.toDataURL(MIME_TYPE);
    } else if (fileType === "JPEG") {
      MIME_TYPE = "image/JPEG";
      let canvas = canvasElement;
      var newCanvas = canvasElement.cloneNode(true);
      var ctx = newCanvas.getContext('2d');
      ctx.fillStyle = "#FFF";
      ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);
      ctx.drawImage(canvas, 0, 0);
      imgURL = newCanvas.toDataURL("image/jpeg");
    }

    var dlLink = document.createElement("a");
    dlLink.download = fileName;
    dlLink.href = imgURL;
    dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(
      ":"
    );

    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
  };

  const exportToSVG = (event, id, fileName, fileType) => {
    $("." + id + " canvas").attr("id", id + "canvas");
    var canvasElement = document.getElementById(id + "canvas");
    var ctx = canvasElement.getContext("2d");

    var image = new Image();
    ctx.drawImage(image, 0, 0);
    const mycanvas = new fabric.Canvas("fabric-canvas", {
      isDrawingMode: false,
    });
    var encodedBase = canvasElement.toDataURL();

    fabric.Image.fromURL(encodedBase, function (image) {
      mycanvas.add(image);
      var dataURL = mycanvas.toSVG({
        width: "600",
        height: "500",
        viewBox: {
            x: 0,
            y: 0,
            width: 500,
            height: 500
        }
    });
      downloadSVGAsPNG(dataURL, fileName);
    });
  };

  const downloadSVGAsPNG = (dataURL, fileName) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(dataURL, "image/svg+xml");

    const svg = doc.querySelector("svg");
    const base64doc = btoa(unescape(encodeURIComponent(svg.outerHTML)));
    const a = document.createElement("a");
    const e = new MouseEvent("click");
    a.download = `${fileName}.svg`;
    a.href = "data:image/svg+xml;base64," + base64doc;
    a.dispatchEvent(e);
  };

  const OpenPDF = (event, id, fileName, fileType) => {
    
    $("." + id + " canvas").attr("id", id + "canvas");
    var canvasElement = document.getElementById(id + "canvas");

      html2canvas(canvasElement).then(function (canvas) {
        var img = canvas.toDataURL(); //image data of canvas
        var doc = new jsPDF();
        doc.addImage(img, 10, 10);
        doc.output('dataurlnewwindow');
      });
    
  };

  const saveAsPDF = (event, id, fileName, fileType) => {
    $("." + id + " canvas").attr("id", id + "canvas");
    var canvasElement = document.getElementById(id + "canvas");

    html2canvas(canvasElement).then(function (canvas) {
      var img = canvas.toDataURL(); //image data of canvas
      var doc = new jsPDF();
      if(id === 'TopTrueDefectChart') { 
        doc.addImage(img, 'JPEG', 0, 0, 150, 100);
      } else {
        doc.addImage(img, 10, 10);
      }
      doc.save(`${fileName}.pdf`);
    });
  };

  const saveAsCSV = (event, id, fileName, fileType, chartData, chartLabels) => {
    if (id === "Components") {
      let data = [];
      chartLabels &&
        chartLabels.map((label, index) => {
          let innerData = [];
          innerData.push(label);
          innerData.push("");
          data.push(innerData);
          chartData.map((chartItem, index) => {
            let innerData = [];
            innerData.push(chartItem.label);
            innerData.push(chartItem.data[0]);
            data.push(innerData);
          });
          innerData = [];
          innerData.push("");
          innerData.push("");
          data.push(innerData);
        });
      exportToCsv(id, data);
    } else if (id === "PrinterLineChart") {
        let data = [];
        chartData.map((chartItem, index) => {
          let innerData = [];
          let timeStamp = moment(chartItem.ts).format('MM/DD/YYYY-h:mm:ss');
          innerData.push(timeStamp);
          innerData.push(chartItem.value);
          data.push(innerData);
        });
        exportToCsv(id, data);
    } else if( id === 'AverageCycleTime') {
        let data = [];
        chartData.data.map((chartItem, index) => {
          let innerData = [];
          let timeStamp = moment(chartItem.ts).format('MM/DD/YYYY-h:mm:ss');
          innerData.push(timeStamp);
          innerData.push(chartItem.value);
          data.push(innerData);
        });
        exportToCsv(id, data);  
    } else if( id === 'TopTrueDefectChart') {
      let data = [];
      chartData.map((chartItem, index) => {
        let innerData = [];
        innerData.push(chartItem.name);
        innerData.push(chartItem.value);
        data.push(innerData);
      });
      exportToCsv(id, data);  
  } else {
      let data = [];
      chartData.labels.map((chartItem, index) => {
        let innerData = [];
        innerData.push(chartItem);
        innerData.push(chartData.datasets[0].data[index]);
        data.push(innerData);
      });
      exportToCsv(`Top Quality Defects.csv`, data);
    }
  };

  const exportToCsv = (filename, rows) => {
    var processRow = function (row) {
      var finalVal = "";
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? "" : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        }
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
        if (j > 0) finalVal += ",";
        finalVal += result;
      }
      return finalVal + "\n";
    };

    var csvFile = "";
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };

  });

  return (
    <div className="download-container" ref={container}>
      <div className="download-icons">
        <div>
          {t("LT_view")}:{" "}
          <i className="fa fa-file-pdf-o download-icon" aria-hidden="true"
          onClick={(event) => OpenPDF(event, chartid, chartid, "pdf")}
          ></i>{" "}
          <br />
        </div>
        <i
          className="fa fa fa-download download-icon"
          onClick={() => setOpen(!open)}
          aria-hidden="true"
        ></i>
      </div>
      {open && (
        <div className="download-dropdown-wrapper">
          <ul className="download-dropdown-menu">
            <li
              className="download-dropdown-menu__item"
              onClick={(event) =>
                exportCanvasAsPNG(event, chartid, chartid, "PNG")
              }
            >
              {t("LT_export_as_png")}
            </li>
            <li
              className="download-dropdown-menu__item"
              onClick={(event) =>
                exportCanvasAsPNG(event, chartid, chartid, "JPEG")
              }
            >
              {t("LT_export_as_jpg")}
            </li>
            <li
              className="download-dropdown-menu__item"
              onClick={(event) => saveAsPDF(event, chartid, chartid, "pdf")}
            >
              {t("LT_export_as_pdf")}
            </li>
            <li
              className="download-dropdown-menu__item"
              onClick={(event) => exportToSVG(event, chartid, chartid, "pdf")}
            >
              {t("LT_export_as_svg")}
            </li>
            <li
              className="download-dropdown-menu__item"
              onClick={(event) =>
                saveAsCSV(
                  event,
                  chartid,
                  chartid,
                  "pdf",
                  chartData,
                  chartLables
                )
              }
            >
              {t("LT_export_as_csv")}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Download;
